// components/NextButtonLink.tsx
import { FunctionComponent, ReactNode, cloneElement, isValidElement, useCallback } from "react";
import { useRouter } from "next/router";

type NextLinkProps = {
  href: string;
  children: ReactNode;
};

const NextLink: FunctionComponent<NextLinkProps> = ({ href, children }) => {
  if (!isValidElement(children)) {
    throw new Error("NextButtonLink requires a valid React element as child");
  }
  const router = useRouter();
  const onClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      router.push(href);
    },
    [router, href],
  );

  const childProps = { onClick, href };

  return cloneElement(children, childProps);
};

export default NextLink;
